import React from 'react';
import RegisterForm from '../components/RegisterForm';

const RegisterPage = ({ onRegisterSuccess }) => {
  return <RegisterForm onRegisterSuccess={onRegisterSuccess} />;
};

export default RegisterPage;